'use strict'

import React from 'react'
import { StyleSheet } from 'react-native'
import { colors } from 'app/fs/lib/styles'

var styles = StyleSheet.create({
  noConversations: {
    textAlign: 'center',
    padding: 20
  }
})

export default styles
